import { render, staticRenderFns } from "./publicFile.vue?vue&type=template&id=0d624182&scoped=true&"
import script from "./publicFile.vue?vue&type=script&lang=js&"
export * from "./publicFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d624182",
  null
  
)

export default component.exports